<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">구분</th>
          <td>
            <div class="item">
              <div class="lft_area" style="width:274px">
                <select name="" id="" class="i_sel" style="width:260px" v-model="categorySeq">
                  <option
                    v-for="category in categoryListForCreate"
                    :value="category.categorySeq"
                  >{{ category.name }}</option>
                </select>
              </div>

              <div class="lft_area divi brd_left">
                <span class="ui_chkbox primary lgray">
                  <input
                    type="checkbox" 
                    name="sort"
                    v-model="topNoticeYn"
                    true-value="Y"
                    false-value="N"
                  >
                  <label for="">
                    <span class="txt noti">중요 상단공지</span>
                  </label>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">제목</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="제목을 입력하세요." v-model="title">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">내용</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" rows="9" class="i_ta type_full lineless" placeholder="상세내용을 입력하세요." v-model="content"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">첨부파일</th>
          <td>
            <div class="item item_attach">
              <p class="note">(확장자는 jpg, pdf, doc, ppt, hwp, zip 만 가능합니다.)</p>
              <div class="ui_attach" v-for="(row, index) in files" :key="index">
                <input type="text" class="i_txt i_file" :value="row.fileName" @click="triggerFileInput(index)" readonly>
                <button type="button" class="bt_base primary btn_attach" @click="triggerFileInput(index)"> 찾아보기</button>
                <button type="button" class="bt_base gray type_ico" @click="removeRow(index)" style="margin-right:5px"> &minus; </button>
                <button type="button" class="bt_base gray type_ico" @click="addRow" v-if="index == 0" > &plus; </button>
                <input type="file" name="file" class="i_upload" style="display: none" @change="handleFileChange(index)" ref="file">
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createNotice">저장</button>
      <!-- <button type="button" class="bt_base gray large_h">수정</button>
      <button type="reset" class="bt_base gray large_h">삭제</button> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const adminNoticeModule = 'adminNoticeModule'
const adminCategoryModule = 'adminCategoryModule'

export default {
  data (){
    return {
      title: '',
      content: '',
      topNoticeYn: 'N',
      categorySeq: '',
      files: [{}]
    }
  },
  methods: {
    ...mapActions(adminNoticeModule, [
      'requestCreateNotice'
    ]),

    ...mapActions(adminCategoryModule, [
      'requestCategoryListForCreate'
    ]),

    triggerFileInput(index) {
      const fileInputs = this.$refs.file;
      if (fileInputs && fileInputs[index]) {
        fileInputs[index].click();
      }
    },

    addRow() {
      this.files.push({});
    },

    removeRow(index) {
      if (this.files.length != 1) {
        this.files.splice(index, 1);
      } else {
        this.files = [{}];
      }
    },

    toList () {
      this.$router.push({ name: "BoardNoticeManageListPage" })
    },

    async createNotice() {
      const content = this.content.replace(/\n/g, '<br>')
      const { title, topNoticeYn, categorySeq, files } = this
      const formData = new FormData();
      formData.append('title', title);
      formData.append('content', content);
      formData.append('topNoticeYn', topNoticeYn);
      formData.append('categorySeq', categorySeq);

      files.forEach((file) => {
        formData.append('files', file.file);
      });

       const noticeSeq = await this.requestCreateNotice(formData)
       if (noticeSeq) {
         alert(noticeSeq)
         this.$router.push({ name: "BoardNoticeManageListPage" })
       }
    },

    handleFileChange (i) {
      const file = this.$refs.file[i].files[0];
      if (file) {
        this.files[i].file = file;
        this.files[i].fileName = file.name;
      }
    }
  },

  computed: {
    ...mapState(adminCategoryModule, ['categoryListForCreate'])
  },

  async mounted() {
    await this.requestCategoryListForCreate('공지사항')
    this.categorySeq = this.categoryListForCreate[0].categorySeq
  }

}
</script>
<style lang="">
    
</style>